import Vue from 'vue'
import {getEncrypt} from "@/utils/pem";

export async function login(data) {
    return Vue.axios({
        url: '/api/auth/login',
        method: 'post',
        data: {
            account: data.account,
            password: await getEncrypt(data.password),
        }
    })
}
//钉钉授权登录
export function loginByDingTalk(auth_code) {
    return Vue.axios({
        url: '/api/auth/loginByDingTalkAuth',
        method: 'post',
        data: { auth_code: auth_code }
    })
}

export function LoginDingDing(data) {
    return Vue.axios({
        url: '/api/auth/dingDingLogin',
        method: 'post',
        data: {...data}
    })
}

export function bindDingDing(data) {
    return Vue.axios({
        url: '/api/auth/bindOrRegister',
        method: 'post',
        data: {...data}
    })
}

//飞书授权码登录
export function loginByFeishuCode(code) {
    return Vue.axios({
        url: '/api/auth/loginByFeishuCode',
        method: 'post',
        data: { code: code }
    })
}

//飞书首次登录（未匹配到账号）：绑定已有账号/注册新账号
export function bindFeishu(data) {
    return Vue.axios({
        url: '/api/auth/bindOrRegisterFeishu',
        method: 'post',
        data: {...data}
    })
}

export function unbindDingDing(data) {
    return Vue.axios({
        url: '/api/users/unbindDingDing',
        method: 'post',
        data: {...data}
    })
}

export function unbindFeishu(data) {
    return Vue.axios({
        url: '/api/users/unbindFeishu',
        method: 'post',
        data: {...data}
    })
}

export function bindFeishuToCurrentUser(data) {
    return Vue.axios({
        url: '/api/users/bindFeishu',
        method: 'post',
        data: {...data}
    })
}

export function getAuth() {
    return Vue.axios({
        url: '/api/auth/me',
        method: 'get',
        params: {}
    })
}

export function logout() {
    return Vue.axios({
        url: '/api/auth/logout',
        method: 'get',
        params: {}
    })
}
